import { render, staticRenderFns } from "./Students.vue?vue&type=template&id=1e9a6762&scoped=true"
import script from "./Students.vue?vue&type=script&lang=js"
export * from "./Students.vue?vue&type=script&lang=js"
import style0 from "./Students.vue?vue&type=style&index=0&id=1e9a6762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9a6762",
  null
  
)

export default component.exports